import { channels } from "@/mocks/scandal";
import SectionHead from "./SectionHead";

export default function ChannelBoard() {
  return (
    <section id="channel" className="scroll-mt-24 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          eyebrow="档案索引 / CHANNELS"
          title="一个黑料档案库，分四个方向进"
          desc="从「深扒」的单点深挖，到「人物起底」的横向建档，再到「背景揭秘」的逐层核验与「内幕」的多源交叉——四个栏目四套拆法，互不重复。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {channels.map((c) => (
            <a
              key={c.id}
              href={"#top"}
              className="group relative flex flex-col justify-between overflow-hidden rounded-lg border border-foreground-950/8 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-foreground-950/20"
            >
              <span className="absolute right-5 top-4 font-heading text-4xl font-black text-background-200/80 transition-colors group-hover:text-primary-100">
                {c.no}
              </span>
              <div>
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${c.icon} text-xl`} />
                </span>
                <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-1 font-label text-[10px] tracking-[0.25em] text-foreground-400">{c.en}</p>
                <p className="mt-3 text-[13px] leading-6 text-foreground-600">{c.desc}</p>
              </div>
              <div className="mt-5 flex items-center justify-between">
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-800">
                  {c.meta}
                </span>
                <span className="flex h-7 w-7 items-center justify-center rounded-full border border-foreground-950/10 text-foreground-500 transition-colors group-hover:border-primary-500 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-up-line text-sm" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}